import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';

import { getAccessToken } from 'src/app/auth/auth';
import { UserService } from 'src/app/auth/user-service';
import { getLocale } from 'src/packages/language/utils';

import { API_GOSTORAGE_WELL_LOGS_URL } from './consts';

const instance = axios.create({
  baseURL: API_GOSTORAGE_WELL_LOGS_URL,
  headers: {
    'content-type': 'application/json',
  },
});

const wellLogsWidgetAgent = setupCache(instance, {
  headerInterpreter: () => {
    return 'not enough headers';
  },
  ttl: 1000 * 10,
});

wellLogsWidgetAgent.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      const accessToken = await UserService.updateToken();

      if (error?.config && accessToken) {
        return axios.request({
          ...error.config,
          headers: {
            ...error.config.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        });
      }
    }

    return Promise.reject(error);
  }
);

wellLogsWidgetAgent.interceptors.request.use((config) => {
  const accessToken = getAccessToken();

  config.headers.set('accept-language', getLocale());

  if (accessToken) {
    config.headers.set('Authorization', `Bearer ${accessToken}`);
  }

  return config;
});

export { wellLogsWidgetAgent };
